/**
 * Application Constants
 * 
 * This file contains all magic numbers and hardcoded values used in the frontend.
 * Centralizing these values makes the code more maintainable and easier to configure.
 */

// Time constants (in milliseconds)
export const TIME = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000
} as const;

// Cache configuration
export const CACHE = {
  TTL: 5 * TIME.MINUTE // 5 minutes
} as const;

// Rate limiting configuration
export const RATE_LIMIT = {
  WINDOW: 1 * TIME.MINUTE, // 1 minute
  MAX_REQUESTS: 2000 // 2000 requests per minute (very high limit for pages with many experts/workplaces)
} as const;

// HTTP Status Codes (for consistency)
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500
} as const;

